const trains = {
  train: "रेलगाड़ी", // translated 
  trains: "ट्रेनें", // translated 
  fairConditions: "उचित शर्तें", // translated 
  to: "को", // translated 
  earlier: "पहले", // translated 
  later: "बाद में", // translated 
  adults: "वयस्कों", // translated 
  child: "बच्चा", // translated 
  senior: "वरिष्ठ", // translated 
  seniors: "वरिष्ठ", // translated 
  price: "कीमत", // translated 
  for: "के लिए", // translated 
  total: "कुल", // translated 
  selected: "चयनित", // translated 
  prebook: "पहले से बुकिंग करें", // translated 
  book: "किताब", // translated 
  payment: "भुगतान", // translated 
  return: "वापस करना", // translated 
  passengers: "यात्रियों", // translated 
  delivery: "वितरण", // translated 
  summary: "सारांश", // translated 
  checkout: "चेक आउट", // translated 
  trainToastCorrectFillForm: "कृपया सभी फ़ील्ड सही ढंग से भरें।", // translated 
  fareConditions: "किराया शर्तें", // translated 
  travelInfo: "यात्रा संबंधी जानकारी", // translated 
  remarks: "ग्राहक की टिप्पणियाँ", // translated 
  noServices: "कोई सेवा उपलब्ध नहीं", // translated 
  timesAndSeats: "समय और सीटें", // translated 
  mobileTicket: "मोबाइल टिकट", // translated 
  stationTicket: "स्टेशन पर इकट्ठा करें", // translated 
  homeTicket: "घर पर प्रिंट करें", // translated 
  countryCode: "कंट्री कोड", // translated 
  chooseTicket: "टिकट वितरण विधि चुनें", // translated 
  ticketError: "कृपया सभी गंतव्यों के लिए टिकट चुनें", // translated 
  ticketDelivery: "कृपया टिकट वितरण विधि का चयन करें", // translated 
  passengerDetails: "यात्री विवरण", // translated 
  waitWhileProcessingPayment:
    "कृपया प्रतीक्षा करें जब तक हम आपके भुगतान की प्रक्रिया पूरी नहीं कर लेते, पेज को रिफ्रेश या बंद न करें।", // translated 
  reductionCardId: "कटौती कार्ड आईडी", // translated 
  countryOfResidence: "निवास का देश", // translated 
  countryOfBirth: "जन्म का देश", // translated 
  documentCountry: "दस्तावेज़ देश", // translated 
  documentNumber: "दस्तावेज़ संख्या", // translated 
  expirationDate: "समाप्ति तिथि", // translated 
  documentType: "दस्तावेज़ प्रकार", // translated 
  travelerDocumentInfo: "यात्री दस्तावेज़ की जानकारी", // translated 
  youth: "युवा", // translated 
  youths: "युवाओं", // translated 
  departTimeEarlyFirst: "प्रस्थान समय (सबसे पहले सबसे पहले)", // translated 
};


export default trains;
